import styled from "@emotion/styled";
import {breakpoints} from "assets/theme";
import pageDescBg from "assets/images/pageDescBg.png";

export const MainWrapper = styled.div`
	display: flex;
	justify-content: stretch;
	align-items: stretch;
	gap: 24px;
	max-width: 1440px;
	width: 100%;
	margin: 0 auto;
	padding: 0;

	@media (min-width: ${breakpoints.tablet}) {
		padding: 24px 60px 0;
	}
`;

export const Main = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	max-width: 872px;
	width: 100%;
	background: ${({theme}) => theme.colorPalette.black};

	@media (max-width: ${breakpoints.tablet}) {
		max-width: unset;
		background: #010101;
	}
`;

export const PageTitleWrapper = styled.div`
	display: none;
	justify-content: center;
	align-items: center;
	padding: 36px 60px;
	background: url(${pageDescBg}) no-repeat center #010101;
	background-size: 100% 100%;
	color: ${({theme}) => theme.colorPalette.white};
	text-align: left;

	@media (min-width: ${breakpoints.tablet}) {
		display: flex;
	}
`;

export const PageTitleContent = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	max-width: 1320px;
	margin: 0 auto;
`;

export const PageTitleImg = styled.img`
	width: 150px;
`;

export const PageTitle = styled.h2`
	font-size: 32px;
	font-weight: 700;
	line-height: 120%;
	letter-spacing: 0.2px;
	text-transform: uppercase;
	margin-bottom: 24px;
`;

export const PageSubTitle = styled.h3`
	font-family: ${({theme}) => theme.secondFont};
	font-size: 16px;
	font-weight: 700;
	line-height: 120%;
	letter-spacing: 0.32px;
`;
